import { baseUrls } from "../popData";

export function findOnGoogleMaps(address = "", postcode = "") {
  let baseUrl = baseUrls.searchGoogleMaps; //"https://www.google.com/maps/place/";

  let encodedAddress = encodeURI(`${address} ${postcode}`);

  window.open(baseUrl + encodedAddress, "_blank");
}

export function searchEmail(e, searchTerm = "") {
  let baseUrl = baseUrls.searchEmail; //"https://mail.google.com/mail/#search/";
  let encodedAddress = encodeURI(searchTerm);

  window.open(baseUrl + encodedAddress, "_blank");
}
